<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="isler_detay">

        <AppMain>

            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between g-3">
                                    <div class="nk-block-head-content">


                                        <h3 class="nk-block-title page-title" v-if="formIslem === 'ekle'">Yeni Görüşme Formu Ekle</h3>
                                        <h3 class="nk-block-title page-title" v-if="formIslem === 'duzenle'">Görüşme Formu Düzenleme
                                        </h3>

                                    </div>
                                    <div class="nk-block-head-content">
                                        <router-link to="/gorusmebilgiler"
                                            class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                                class="icon ni ni-arrow-left"></em><span>Tüm Görüşmeler</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <form @submit.prevent="gonder">

                            <div class="row">
                            <div class="col-sm-8">
                            

                                   
                                
                         


                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">Hızlı Görüşme Ekleme</span>
                                        <div class="row gy-4">

                  
                                        <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.etkinlik }">
                                                    <label class="form-label" for="default-textarea">Etkinlik</label>
                                                    <div class="form-control-wrap">
                                                        <v-select
                                                        v-model="localFormData.etkinlik"
                                                        :options="etkinlikler"
                                                        label="ad"
                                                        :reduce="etkinlik => etkinlik.id"
                                                        placeholder="Etkinlik Seçin"
                                                        />
                                                    </div>
                                                    <span v-if="formHatalar.etkinlik" class="error">{{ formHatalar.etkinlik }}</span>
                                                </div>
                                            </div>


                                        


                                            
                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.tarih }">
                                                    <label class="form-label" for="tarih">Görüşme Tarihi</label>
                                                    <div class="form-control-wrap">
                                                         <VueCtkDateTimePicker 
                                                         itemid="tarih"
                                                        color="#364a63"
                                                        button-color="#5A770E" v-model="localFormData.tarih"
                                                        format="YYYY-MM-DD HH:mm:ss" label="Görüşme Tarihi Seçiniz"
                                                        button-now-translation="Bugün" />
                                                    </div>
                                                    <span v-if="formHatalar.tarih" class="error">{{ formHatalar.tarih }}</span>
                                                </div>
                                            </div>

                                     
                                    

                                         

                                        
                                        </div>
                                 
                                 
                                    </div>
                                </div>
                            </div>

                        

                            <div class="card card-bordered card-preview mb-2">
                                <div class="card-inner">
                                    <div class="preview-block">
                                        <div class="row gy-4">
                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.not }">
                                                    <label class="form-label" for="default-textarea">Not</label>
                                                    <div class="form-control-wrap">
                                                        <textarea class="form-control no-resize" rows="8"   id="not" v-model="localFormData.not"> </textarea>
                                                    </div>
                                                    <span v-if="formHatalar.not" class="error">{{ formHatalar.not }}</span>
                                                </div>
                                            </div>
           
                                        </div>
                                </div>
                            </div>
                        </div>


                        

                    
                  
                    
                      
                        </div>
                        <div class="col-sm-4">

                          
                            <div class="card card-bordered card-preview mb-2">
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">SES KAYDEDİCİ</span>
                                        

                                        <div class="row gy-4">
                                            <button type="button" class="btn btn-primary rounded-pill" @click="startRecording" :disabled="isRecording"> <em class="icon ni ni-mic"></em>Kayda Başla</button>
                                            <button type="button" class="btn btn-primary rounded-pill" @click="stopRecording" :disabled="!isRecording"> <em class="icon ni ni-stop"></em> Kaydı Durdur</button>
                                            <audio v-if="audioURL" :src="audioURL" controls></audio>
                                        </div>
                                </div>
                            </div>  
                        </div> 

                            <div class="card card-bordered card-preview mb-2">
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">GÖRÜŞME BELGELERİ</span>
                                        <div class="row gy-4">
                                            

                                      



<div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.kartviziton }"> 
       
    <img 
    v-if="localFormData.kartviziton" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + localFormData.kartviziton" 
    alt="Kartvizit Ön Görsel" 
  />
    

       <picture-input 
         ref="profil"
         width="600" 
         height="600" 
         margin="16" 
         accept="image/jpeg,image/png" 
         size="10" 
         button-class="btn"
         :custom-strings="{
           upload: '<h1>Kartvizit Ön Görsel</h1>',
           drag: 'Kartvizit Ön Görseli Tıklayın veya sürükleyip bırakın'
         }"
         @change="kartvizitonDegistir">
       </picture-input>
     </div>	
       <span v-if="formHatalar.kartviziton" class="error">{{ formHatalar.kartviziton }}</span>
  
   
   <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.kartvizitarka }"> 
      

    <img 
    v-if="localFormData.kartviziton" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + localFormData.kartvizitarka" 
    alt="Kartvizit Arka Görsel" 
  />


       <picture-input 
         ref="profil"
         width="600" 
         height="600" 
         margin="16" 
         accept="image/jpeg,image/png" 
         size="10" 
         button-class="btn"
         :custom-strings="{
           upload: '<h1>Kartvizit Arka Görsel</h1>',
           drag: 'Kartvizit Arka Görseli Tıklayın veya sürükleyip bırakın'
         }"
         @change="kartvizitarkaDegistir">
       </picture-input>
     </div>	
       <span v-if="formHatalar.kartvizitarka" class="error">{{ formHatalar.kartvizitarka }}</span>
  
                                     
                                        

                                        
                                        </div>
                                 
                                 
                                    </div>
                                </div>
                            </div>


                        </div>
                      
                        <div class="col-sm-12 justify-content-end mt-4">
                            <button type="submit" class="btn btn-primary"><em
                                                    class="icon ni ni-check"></em><span>Kaydet</span></button>
                        </div>
                        </div>
                

                                    </form>
                           


                        </div>
                    </div>
                </div>

            </div>




        </AppMain>
    </div>
</template>



<script>
import axiosCustom from "@/services/axiosCustom";
import AppMain from "@/components/AppMain.vue";
import vSelect from "vue-select";




import PictureInput from 'vue-picture-input'



import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';





export default {
components: {
    AppMain,
      vSelect,
  
  
    PictureInput,
  
  
  
    VueCtkDateTimePicker,
  
  

  
},

data() {
  return {
    
    kartvizitonSecili: null,
    
    kartvizitarkaSecili: null,
    
    
  firmalar: [],
  tumfirmalar: [],
  
  etkinlikler: [],
  
  kisiler: [],
  tumkisiler: [],
  
  kullanicilar: [],
  
  aktifSekme:'bilgiler',

  
    localFormData: { ...this.formData }, 
    formHatalar:{},

   formIslem:'ekle', 

     

   mediaRecorder: null,
      audioChunks: [],
      audioURL: null,
      isRecording: false,
  

  };
},
created() {
  
    this.tarihlerOtomatikDoldur() 

  
  this.etkinliklerGetir();

  
   

  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },
  
    },
methods: {
  

   



  async etkinliklerGetir() {
    try {
      const response = await axiosCustom.get("etkinlikler"); 
      this.etkinlikler = response.data;
      this.otomatikEtkinlikSec();
    } catch (error) {
      console.error("etkinlikler alma hatası: ", error);
    }
  },
  

  formatDate(tarih) {
    // 'YYYY-MM-DD HH:mm:ss' formatını 'YYYY-MM-DDTHH:mm:ss' formatına çevir
    return tarih.replace(' ', 'T');
  },
  
  otomatikEtkinlikSec() {
    // Etkinlikleri döngüyle kontrol et
    this.etkinlikler.forEach(etkinlik => {
      // Tarihleri formatDate fonksiyonuyla düzenle ve Date nesnesine çevir
      let basTarih = new Date(this.formatDate(etkinlik.bastarih));
      let bitisTarih = new Date(this.formatDate(etkinlik.bittarih));

      // Eğer bugünün tarihi basTarih ve bitisTarih arasında ise
      if (new Date() >= basTarih && new Date() <= bitisTarih) {
        this.localFormData.etkinlik = etkinlik.id;
      }
    });
  },

  
  
  tarihlerOtomatikDoldur() {
            const today = new Date();

            // Tarih formatını YYYY-MM-DD HH:mm:ss şeklinde ayarlıyoruz.
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };

            this.localFormData.tarih = formatDate(today);

          
        },


  formDogrula() {
    this.formHatalar = {};
    var kontrol=true;
    
      
    if (!this.localFormData.etkinlik) {
        this.formHatalar.etkinlik = "Etkinlik boş bırakılamaz.";
        kontrol=false;
      }

    return kontrol;
  },
  async  gonder() {
    if(this.formDogrula()){
  // FormData oluştur
  const newFormData = new FormData();

  if (this.audioChunks.length > 0) {
  const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
  newFormData.append('audio', audioBlob, 'recording.wav');

}

  newFormData.append("etkinlik", this.localFormData.etkinlik);
  newFormData.append("not", this.localFormData.not);
  newFormData.append("tarih", this.localFormData.tarih);


   
  newFormData.append("kartviziton",  this.kartvizitonSecili);
  newFormData.append("kartvizitarka",  this.kartvizitarkaSecili);



  try {

    axiosCustom
      .post("gorusmebilgiler/hizliekle", newFormData)
      .then(() => {
        

        this.$toast.success("Yeni Görüşme Bilgi Eklendi");
        this.$router.push('/gorusmebilgiler');
      })
      .catch((error) => {
        console.error("Ekleme hatası: ", error);
        this.$toast.error("Ekleme hatası");
      });
  
} catch (error) {
    console.error('Kaydetme hatası: ', error);
    this.$toast.error('Kaydetme hatası');
  }
} 
  },
  
  iptalEt() {
    this.formIptal();
  },

  

  
  kartvizitonDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.kartvizitonSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.kartvizitonSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.kartvizitonOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.kartvizitonSecili);
        }
    },
    
  kartvizitarkaDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.kartvizitarkaSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.kartvizitarkaSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.kartvizitarkaOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.kartvizitarkaSecili);
        }
    },





    async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(stream);
      this.audioChunks = [];

      this.mediaRecorder.start();
      this.isRecording = true;
      this.$toast.success('Ses kaydı başlatıldı.');

      this.mediaRecorder.ondataavailable = (event) => {
        this.audioChunks.push(event.data);
      };

      this.mediaRecorder.onstop = () => {
        const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
        this.audioURL = URL.createObjectURL(audioBlob);
        this.$toast.success('Ses kaydı durduruldu.');
      };
    } catch (error) {
      console.error('Mikrofon erişim hatası:', error);
      this.$toast.error('Mikrofon erişim hatası: ' + error.message);
    }
  },

  stopRecording() {
    if (this.isRecording) {
      this.mediaRecorder.stop();
      this.isRecording = false;
    }
  },

  uploadAudio() {
    const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
    const formData = new FormData();
    formData.append('audio', audioBlob, 'recording.wav');

    // Burada ses kaydını yükleyeceğiniz API'ye isteği gönderin
    fetch('YOUR_API_ENDPOINT', {
      method: 'POST',
      body: formData,
    })
    .then(response => {
      if (response.ok) {
        this.$toast.success('Ses kaydı başarıyla yüklendi.');
      } else {
        console.error('Yükleme sırasında bir hata oluştu');
        this.$toast.error('Yükleme sırasında bir hata oluştu.');
      }
    })
    .catch(error => {
      console.error('Yükleme sırasında bir hata oluştu', error);
      this.$toast.error('Yükleme sırasında bir hata oluştu: ' + error.message);
    });
  }


 
    
},
};
</script>

  